module.exports = __webpack_public_path__ + "img/squareup.16c8e813.png";